// One code catalog; consumers intentionally recognize different subsets. Keep extraction,
// message matching and status precedence at the call site (CYBO-1917).
const R = 1, E = 2, I = 4, D = 8, P = 16, T = 32, X = 64;
const SCOPES = {
    relay: R,
    encoder: E,
    integration: I,
    desktop: D,
    provider: P,
    transport: T,
    "provider-text": X,
};
const NETWORK_CODES = [
    ["ECONNRESET", R | E | I | D | P | T | X],
    ["ECONNREFUSED", R | E | I | D | T | X],
    ["ECONNABORTED", R | D | P | T | X],
    ["EPIPE", R | E | I | D | P | T | X],
    ["ETIMEDOUT", R | E | I | D | P | T | X],
    ["ENOTFOUND", R | E | I | D | T | X],
    ["EAI_AGAIN", R | E | I | D | T | X],
    ["ENETUNREACH", R | E | I | D | T | X],
    ["ENETDOWN", R | D | T],
    ["EHOSTUNREACH", R | E | I | D | T | X],
    ["EHOSTDOWN", R | T],
    ["UND_ERR_SOCKET", E | I | P | T],
    ["UND_ERR_CONNECT_TIMEOUT", E | I | T],
    ["UND_ERR_HEADERS_TIMEOUT", I | T],
    ["ERR_NETWORK_CHANGED", D],
    ["ERR_NAME_NOT_RESOLVED", D],
    ["ERR_TIMED_OUT", D],
    ["ERR_INTERNET_DISCONNECTED", D],
    ["ERR_NETWORK_IO_SUSPENDED", D],
    ["ERR_CONNECTION_TIMED_OUT", D],
    ["ERR_CONNECTION_RESET", D],
    ["ERR_CONNECTION_REFUSED", D],
    ["ERR_CONNECTION_CLOSED", D],
    ["ERR_CONNECTION_ABORTED", D],
    ["ERR_CONNECTION_FAILED", D],
    ["ERR_ADDRESS_UNREACHABLE", D],
    ["ERR_PROXY_CONNECTION_FAILED", D],
    ["ERR_NAME_RESOLUTION_FAILED", D],
    ["ERR_EMPTY_RESPONSE", D],
    ["ERR_CONTENT_LENGTH_MISMATCH", D],
    ["ERR_INCOMPLETE_CHUNKED_ENCODING", D],
    ["ERR_SOCKET_NOT_CONNECTED", D],
    ["ERR_QUIC_PROTOCOL_ERROR", D],
    ["ERR_HTTP2_PING_FAILED", D],
    ["ERR_HTTP2_PROTOCOL_ERROR", D],
    ["ERR_HTTP2_SERVER_REFUSED_STREAM", D],
    ["ERR_HTTP2_STREAM_ERROR", D],
    ["responseStreamDisconnected", P],
    ["UND_ERR_BODY_TIMEOUT", T],
];
/** The caller's established subset, not the union: widening it changes fault/retry semantics. */
export function networkErrorCodesFor(scope) {
    return NETWORK_CODES.filter(([, scopes]) => (scopes & SCOPES[scope]) !== 0).map(([code]) => code);
}
//# sourceMappingURL=network-error-codes.js.map